import React from 'react';
import PageView from '../components/sections/PageView';

const ContactPage = () => {
  return (
    <div data-testid="contact-page-wrapper">
      <PageView slug="contact" />
    </div>
  );
};

export default ContactPage;
